import { getJSONFromHtml } from '../../domain/common';
import { IPersonalizationData } from './personalization-interfaces';
import {
    findPersonalizationItems, handleGroupFallbacks,
    PERSONALIZATION_PLACEHOLDER_ID, preparePersonalizationData, showPersonalizationItems,
} from './domain/personalization-provider';

/**
 * New:
 * https://wavesaudio.atlassian.net/browse/DSWEB-4709
 *
 * Old:
 * https://wavesaudio.atlassian.net/browse/DSWEB-4243
 * <script src="{% ReactResource("personalization.js")%}"></script>
 */
export const initPersonalization = () => {
    /*
    printed on page:
    New:
    -------------------
    <div id="prs-data">@ViewBag.LayoutModel.UserDataJSON</div>

    Old:
    -------------------
    <div id=user-has-perpetual-products>True</div>
    <div id=user-has-active-wca>True</div>

    script to handle:
    <div data-user-has-perpetual="false" class="hidden">SBS banner for users with no perpetual products</div>
    <div data-user-has-perpetual="true" class="hidden">Sale banner for users with perpetual products</div>
    <div data-user-has-active-wca="true" class="hidden">Lorem Ipsum</div>
    <div data-user-has-active-wca="false" class="hidden">Lorem Ipsum</div>
    */

    const data: IPersonalizationData|null = getJSONFromHtml(document.getElementById(PERSONALIZATION_PLACEHOLDER_ID)) as IPersonalizationData;
    if(!data) return;

    const map = preparePersonalizationData(data);

    const items = findPersonalizationItems();

    showPersonalizationItems(map, items);

    handleGroupFallbacks();

    // Hide all preloaders on the page (if there are any)
    document.querySelectorAll('[data-user-preloader]')?.forEach($preloader => {
        $preloader.classList.add('hidden');
    });
};

